export class SecuritiesEnvironment {
  public static getName = () => 'benzinga-securities';
  public static getEnvironment = (env: Record<string, string>) => ({
    insiderUrl: new URL(env.insiderUrl ?? 'https://www.benzinga.com/sec/'),
    key: env.key ?? '',
    peersKey: env.peersKey ?? '',
    peersUrl: new URL(env.peersUrl ?? 'https://data-api-pro.benzinga.com/rest/'),
    url: new URL(env.url ?? 'https://data-api-next.benzinga.com/rest/'),
  });
}
